import { EnvironmentConfig } from '@nibras/core/common';

declare const process: {
  env: {
    APIBASEURL: string;
  };
};

export const environment: EnvironmentConfig = {
  production: true,
  apiBaseUrl: '#{NIBRAS_API_BASE_URL}#',
  apiBaseUrlNibrasOne: '#{NIBRASONE_API_BASE_URL}#',
  apiBaseFolder: 'api',
  client_id: 'ngAuthApp',
  //ticketAppId: 364962,
   //roleDelegateAppId: 458390
};
